import instance from '@/services/repository';

const resource = '/dashboards';

export default {
    get() {
        return instance.get<IDashboardListItemDto[]>(`${resource}`);
    },
    getSingle(id: string) {
        return instance.get<IDashboard>(`${resource}/${id}`);
    },
    create(payload: IDashboardCreateDto) {
        return instance.post<IDashboard>(`${resource}`, payload);
    },
    updateAdvanced(payload: IDashboard) {
        return instance.put(`${resource}`, payload);
    },
    updateBasics(payload: IDashboard) {
        return instance.put(`${resource}/basics`, payload);
    },
    delete(id: string) {
        return instance.delete(`${resource}/${id}`);
    },
};
